import { useState } from "react";

// Helper function that handles setting the current image index and implements swiping functionality to
// navigate the images

export function useSwipe(images, setIndex) {

  const [touchStartX, setTouchStartX] = useState(null);

  // Set the image index
  const handlePrev = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  // Swipe the image to the left/right depending on the direction of the swipe
  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;

    if (diff > 50) {
        handleNext();
    } else if (diff < -50) {
        handlePrev();}

    setTouchStartX(null);
  };

  return {handleTouchStart, handleTouchEnd, handlePrev, handleNext};
}